'use client';

import React from 'react';
import { Box, Link } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import AldarLogo from '@components/AldarLogo';
import { LanguageDropdown } from '@components/LanguageDropdown';
import cn from './style.module.scss';
export default function AlGhadeerHeader(props: MarketingPageComponentProps) {
  const headerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'header' && section.enabled
  );
  if (!headerSection) return null;
  return (
    <DynamicScrollHeader
      headerClassName={cn.alGhadeerHeaderWrapper}
      scrolledClassName={cn.alGhadeerHeaderScroll}
    >
      <Box className={cn.alGhadeerHeaderInner}>
        <Box className={cn.alGhadeerHeaderBlock}>
          <Box className={cn.alGhadeerHeaderLanguage}>
            <LanguageDropdown
              className={cn.alGhadeereHeaderLanguage}
              options={props.langOptions || []}
            />
          </Box>
          <Box className={cn.alGhadeerHeaderBrand}>
            <Link
              className={cn.alGhadeerBrandElement}
              href="https://www.aldar.com/properties/en"
              target="_blank" rel="noopener noreferrer"
            >
              <AldarLogo color="white" />
            </Link>
          </Box>
        </Box>
      </Box>
    </DynamicScrollHeader>
  );
}
